package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.VoidPluralString
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String

public object StringsPl : Strings {
  override val locale: String = "pl"

  override val app_name: String? = null

  override val home_screen: String? = null

  override val education_screen: String? = null

  override val skills_screen: String? = null

  override val experience_screen: String? = null

  override val projects_screen: String? = null

  override val project_details_screen: String? = null

  override val social_media_screen: String? = null

  override val achievements_screen: String? = null

  override val homepage_description: String =
      "Pasjonuję się informatyką i rozwijam się w tworzeniu aplikacji na Androida"

  override val homepage_tutor_website: String = "Moja strona korepetycji"

  override val main: String = "Strona główna"

  override val skills: String = "Umiejętności"

  override val projects: String = "Projekty"

  override val experience: String = "Doświadczenie"

  override val education: String = "Edukacja"

  override val social_media: String = "Social Media"

  override val achievements: String = "Osiągnięcia"

  override val resume: String = "CV"

  override val no_results: String = "Nie udało się niczego znaleźć..."

  override val search_placeholder: String = "Wyszukaj..."

  override val search: String = "Szukaj"

  override val home_description: String =
      "Jestem pasjonatem programowania, w szczególności aplikacji na Androida. Na tej stronie możesz przejrzeć moje umiejętności, projekty i osiągnięcia."

  override val skills_description: String =
      "Posiadam różnorodne umiejętności programistyczne, od aplikacji, przez tworzenie obrazów i dokumentów, po tworzenie animacji."

  override val projects_description: String =
      "Pracowałem nad wieloma projektami, od aplikacji mobilnych po gry komputerowe."

  override val experience_description: String =
      "Mam doświadczenie w pracy jako korepetytor matematyki oraz w tworzeniu aplikacji."

  override val education_description: String =
      "Ukończyłem studia licencjackie z informatyki na Uniwersytecie Jagiellońskim oraz technikum informatyczne."

  override val social_media_description: String =
      "Możesz mnie znaleźć na różnych platformach społecznościowych, gdzie dzielę się moimi animacjami matematycznymi."

  override val achievements_description: String =
      "Osiągnąłem wiele sukcesów w konkursach programistycznych, matematycznych i nie tylko, a także zdobyłem stypendia za moje osiągnięcia."

  override val skills_button: String = "Skills"

  override val projects_button: String = "Projects"

  override val experience_button: String = "Experience"

  override val education_button: String = "Education"

  override val social_media_button: String = "Social Media"

  override val achievements_button: String = "Achievements"

  override val view_more: String = "Zobacz więcej"

  override val stack_title: String? = null

  override val hero_label: String = "// cześć, jestem"

  override val hero_title_name: String = "Michał Cyran"

  override val story_label: String = "// moja historia"

  override val story_intro: String =
      "Przygodę z Kotlinem zacząłem na studiach. Po uzyskaniu tytułu licencjata, spędziłem 2 lata na zagłębienie się w ten język. W tym czasie napisałem wiele róznych aplikacji. Możesz je przejrzeć na stronie Projekty."

  override val focus_title: String = "// obecnie uczę się"

  override val focus_coroutines: String =
      "Obecnie zgłębiam wiedzę na temat Coroutines w Kotlinie. Zamierzem przejść przez 15 projektów, z których każdy dotyczy innego aspektu coroutines, od podstaw do zaawansowanych rzeczy."

  override val focus_coroutines_link_label: String = "Zobacz repozytorium"

  override val beyond_title: String = "// poza programowaniem"

  override val beyond_tutoring: String =
      "Pracuję jako korepetytor matematyki, co potwierdza moją inteligencję matematyczną (a co za tym idzie - rozwiązywanie problemów), ale też umiejętność komunikacji z ludźmi oraz zdolność do prowadzenia biznesu."

  override val learning_title: String = "// nieustanne rozwijanie się"

  override val learning_book: String = "Przeczytałem: Kotlin in Action"

  override val learning_channels: String =
      "Regularnie oglądam: KotlinConf, Dave Leeds, Philipp Lackner, Stevdza-San"

  override val skills_title: String = "Umiejętności techniczne"

  override val skills_subtitle: String =
      "Zbiór moich języków programowania, frameworków i innych umiejętności technicznych."

  override val programming_languages: String = "Języki programowania"

  override val frameworks: String = "Frameworki"

  override val markup_style: String = "Języki znaczników"

  override val libraries: String = "Biblioteki"

  override val languages: String = "Języki"

  override val beginner: String = "Początkujący"

  override val competent: String = "Kompetentny"

  override val proficient: String = "Biegły"

  override val advanced: String = "Zaawansowany"

  override val expert: String = "Ekspert"

  override val native: String = "Ojczysty"

  override val c1: String = "C1"

  override val projects_title: String = "Projekty programistyczne"

  override val projects_subtitle: String =
      "Zbiór moich projektów programistycznych, które pokazują moje umiejętności i doświadczenie w tworzeniu oprogramowania."

  override val mobile_application: String = "Aplikacja mobilna"

  override val web_application: String = "Aplikacja webowa"

  override val desktop_application: String = "Aplikacja desktopowa"

  override val multiplatform_application: String = "Aplikacja wieloplatformowa"

  override val library: String = "Biblioteka"

  override val console_application: String = "Aplikacja konsolowa"

  override val game: String = "Gra"

  override val other: String = "Inne"

  override val commercial_project: String = "Komercyjne"

  override val academic_project: String = "Akademickie"

  override val tools_project: String = "Narzędzia"

  override val practice_project: String = "Projekty dla praktyki"

  override val personal_project: String = "Osobiste"

  override val project_overview: String = "Opis projektu"

  override val technical_overview: String = "Opis techniczny"

  override val release_year: String = "Rok wydania"

  override val tech_stack: String = "Technologie"

  override val technical_description_placeholder: String =
      "Opis techniczny nie został jeszcze przygotowany"

  override val screenshots: String = "Zrzuty ekranu"

  override val projects_master_system_shortDescription: String =
      "Aplikacja do zarządzania turniejami z niestandardowym algorytmem"

  override val projects_master_system_description: String =
      "Ta aplikacja do zarządzania turniejami została opracowana na zlecenie, aby ułatwić rozgrywki według algorytmu specyficznego dla klienta. Aplikacja zapewnia przyjazny interfejs do wprowadzania wyników meczów, automatycznie paruje drużyny na kolejną rundę na podstawie algorytmu, oblicza punkty i generuje podsumowania rozgrywek w postaci pliku PDF. Aplikacja wykonuje także grafy, które reprezentują logikę algorytmu parowania drużyn. Aplikacja jest przetłumaczona na cztery języki za pomocą modułu gettext w Pythonie, co zapewnia dostępność dla zróżnicowanej grupy użytkowników. Ten projekt pokazuje moją zdolność do dostarczania dostosowanych, wielojęzycznych rozwiązań programowych, które spełniają specyficzne wymagania klienta i usprawniają zarządzanie złożonymi strukturami turniejowymi."

  override val projects_master_system_technicalDescription: String =
      "Aplikacja do zarządzania turniejami wykonana na zlecenie, implementująca własny algorytm parowania drużyn klienta. Aplikacja pierwotnie zbudowana w Pythonie z KivyMD – z uwagi na potrzebę wsparcia przeglądarki i urządzeń mobilnych w przyszłości, projekt został zmigrowany do Kotlin Multiplatform. Aktualna wersja oparta na Compose Multiplatform (WasmJS) ze współdzielonym UI między platformami – wspierane są Compose Desktop (JVM) oraz wersja webowa. Architektura MVI, nawigacja przez Navigation 3, brak backendu. Dane persystowane lokalnie – w localStorage przez Kotlin/JS API na przeglądarce oraz w plikach JSON na desktopie."

  override val projects_asertiv_shortDescription: String = "Aplikacja do treningu asertywności"

  override val projects_asertiv_description: String =
      "Aplikacja do treningu asertywności. Stworzona we współpracy ze studentem psychologii. Aplikacja przypisuje użytkownikowi stopniowo coraz trudniejsze zadania, które rozwijają jego asertywność. Użytkownik sam wybiera dni, w których chce je wykonywać. Zaimplementowałem niestandardowy, rozbudowany algorytm dla obliczania serii dni użytkownika, który uwzględnia zamrożenia czasu, zadania poboczne, dni wolne, pominięcia zadań. Użytkownik może śledzić swoje postępy w formie listy wykonanych zadań lub kalendarza z zaznaczonymi dniami, w których wykonał jakieś zadanie. Może też dodawać własne notatki do zadań. Aplikacja oferuje też wiedzę psychologiczną wraz z różnymi technikami psychologicznymi, do których odnoszą się niektóre zadania."

  override val projects_asertiv_technicalDescription: String =
      "Zadania zapisane są w bazie danych z użyciem Room. Techniki, zadania, postęp użytkownika są oczywiście rozdzielone na osobne tabele, przez co aplikacja musi wykonywać nietrywialne kwerendy SQL do poprawnego łączenia danych. Algorytm serii dni uwzględniającej wymienione w opisie obok czynniki był na tyle skomplikowany, że żaden model AI nie był w stanie go napisać, zatem stworzyłem go sam od podstaw. Sekcja \"Wiedza\" w aplikacji została stworzona w postaci pliku .md, by mój współtwórca (niezwiązany z informatyką) mógł go prosto przygotować, aplikacja zaś przerabia go na natywny interfejs w Jetpack Compose z użyciem odpowiedniej biblioteki."

  override val projects_vl_shortDescription: String =
      "Aplikacja mobilna dla graczy Valoranta, która pomaga im podczas rozgrywki."

  override val projects_vl_description: String =
      "Aplikacja mobilna dla graczy Valoranta, która pomaga im podczas rozgrywki. Aplikacja oferuje szeroką kolekcję lineupów, umożliwiając graczom wykonywanie zaawansowanych technik bez konieczności wcześniejszego zapamiętywania specyficznych ustawień na mapie. Dzięki aplikacji gracze mogą osiągać lepsze rezultaty w grze i zdobywać wyższe rangi. Była to pierwsza aplikacja tego typu do Valoranta dostępna na sklepie Play, osiągnęła sukecs w postaci ponad 100 tysięcy pobrań. Ten projekt podkreśla moje umiejętności w dostarczaniu innowacyjnych i skutecznych projektów."

  override val projects_vl_technicalDescription: String =
      "Aplikacja zbudowana w Kotlin Multiplatform z UI opartym na Compose Multiplatform – dostępna jako aplikacja na Androida oraz aplikacja webowa hostowana na GitHub Pages. Architektura oparta na MVI, ze współdzieloną logiką biznesową i ViewModelami w commonMain; elementy specyficzne dla platformy realizowane przez mechanizm expect/actual (np. sprawdzanie aktualizacji przez Google Play – niedostępne w przeglądarce).  Dane aplikacji przechowywane są w plikach JSON bundlowanych z aplikacją – generowanych skryptem w Pythonie odpytującym bazę danych przez surowe zapytania SQL. Takie podejście wynika z ograniczeń Room, który nie wspiera inicjalizacji bazy danych z pliku na platformach innych niż Android. Ulubione lineupy użytkownika zapisywane są natomiast w Room na obu platformach, zapewniając zapis danych na urządzeniu bez potrzeby backendu. Komunikacja HTTP realizowana przez Ktor Client (silnik OkHttp na Androidzie, JS na web) z serializacją przez kotlinx.serialization – używany do komunikacji z Firebase Authentication przy logowaniu przez OAuth 2.0 konta Riot Games. Zdjęcia ładowane są z publicznego bucketu Cloudflare R2 i cache'owane przez Coil. Nawigacja oparta na Navigation 3 z type-safe routes."

  override val projects_demiurg_shortDescription: String =
      "Zestaw 2 aplikacji: kreatora i interpretatora gier tekstowych"

  override val projects_demiurg_description: String =
      "Demiurg to aplikacja opracowana w ramach kursu Inżynierii Oprogramowania, stworzona przez zespół pięciu osób. Projekt składa się z dwóch osobnych aplikacji: kreatora i interpretatora gier tekstowych. Kreator pozwala użytkownikom projektować złożone światy gier z mechanikami takimi jak nieliniowe zadania. Umożliwia tworzenie szczegółowych interaktywnych narracji, podczas gdy interpretator zapewnia immersyjne doświadczenie podczas grania. Ten projekt pokazuje moją umiejętność do pracy w zespole, jak i tworzenie niezależnych, ale jednocześnie kooperujących programów."

  override val projects_demiurg_technicalDescription: String =
      "Zarówno interpreter, jak i kreator zostały stworzone w Pythonie, interfejs w KivyMD, z wcześniejszym designem w Figmie. Między aplikacjami został ustalona ustalona komunikacja na zasadzie plików JSON. Kreator tworzy te pliki, a interpreter je odczytuje. Do projektu zostały też przygotowane testy, dostępne w repozytorium na GitHubie."

  override val projects_daymath_shortDescription: String =
      "Aplikacja edukacyjna zawierająca quizy matematyczne, wyjaśnienia i animacje."

  override val projects_daymath_description: String =
      "DayMath to aplikacja edukacyjna, skierowana do uczniów polskich szkół podstawowych i średnich. Aplikacja ma na celu usprawnienie nauki matematyki poprzez różnorodne interaktywne funkcje, w tym quizy matematyczne, szczegółowe tekstowe wyjaśnienia różnych tematów oraz animacje wizualizujące i wyjaśniające złożone problemy. Te narzędzia współpracują ze sobą, aby zapewnić angażujące i skuteczne doświadczenie edukacyjne. Jest to mój najbardziej zaawansowany projekt, który łączy wiele technologii. Sama aplikacja jest wykonana w Kotlinie, jednak teksty do zadań wymagały użycia LaTeXa, a ten z kolei jest dobrze wspierany w Pythonie. Aplikacja łączy się także z Firebasem, gdzie zapisywane są postępy użytkoników w nauce. Ten projekt podkreśla moje zaangażowanie w rozwój mojej działalności korepetytora oraz łączy moje umiejętności informatyczne, matematyczne, edukacyjne oraz lingwistyczne."

  override val projects_daymath_technicalDescription: String =
      "Aplikacja Android zbudowana w Kotlin z UI opartym na Jetpack Compose, architektura MVI. Kod podzielony na pakiety core oraz features, każdy z wewnętrznym podziałem na warstwy data, domain i presentation. Kluczową częścią aplikacji jest rozbudowany moduł ćwiczeń matematycznych – od podstawowych (tabliczka mnożenia, zamiana jednostek) po zaawansowane (odczytywanie własności funkcji z wykresu, generatory równań liniowych i nierówności). Logika ćwiczeń oparta jest na abstrakcyjnych klasach i interfejsach reprezentujących generyczne ćwiczenie, co eliminuje powtarzanie kodu między implementacjami. Na potrzeby renderowania równań napisane zostały własne klasy reprezentujące obiekty matematyczne (wyrażenia, równania, nierówności) wraz z ich renderowaniem w Compose – z uwagi na brak natywnego wsparcia LaTeX na Androidzie.  Dane przechowywane lokalnie w Room z dostępem przez ORM (DAO) i reaktywnym odczytem przez Kotlin Flow i coroutines. Komunikacja z Firebase realizowana przez Ktor Client (silnik OkHttp) z serializacją przez kotlinx.serialization – aplikacja korzysta z Firebase Authentication (logowanie kontem Google) oraz Firestore jako zdalnej bazy danych. Nawigacja oparta na Navigation 3 z type-safe routes."

  override val projects_movie_ai_shortDescription: String =
      "Aplikacja desktopowa rekomendująca filmy na podstawie ocen użytkownika"

  override val projects_movie_ai_description: String =
      "System Rekomendacji Filmów to aplikacja desktopowa stworzona we współpracy z kolegą w ramach kursu Podstaw Sztucznej Inteligencji. Ta aplikacja umożliwia użytkownikom ocenianie filmów, które obejrzeli, i wykorzystuje algorytmy AI do rekomendowania nowych filmów dostosowanych do ich preferencji. Analizując oceny użytkowników i stosując zaawansowane techniki rekomendacji, system dostarcza spersonalizowane propozycje filmów, poprawiając doświadczenie użytkownika związanego z oglądaniem. Ten projekt podkreśla nasze praktyczne zastosowanie zasad AI i naszą zdolność do tworzenia inteligentnych rozwiązań programowych zorientowanych na użytkownika."

  override val projects_movie_ai_technicalDescription: String =
      "Zbudowany na podstawie algorytmu SVD (Singular Value Decomposition). Bardziej szczegółowe omówienie dostępne w pliku .pdf w repozytorium."

  override val projects_generator_tabliczek_shortDescription: String =
      "Aplikacja generująca tabliczki z numerami pokoi oraz nazwiskami"

  override val projects_generator_tabliczek_description: String =
      "Aplikacja ta została stworzona we współpracy z kolegą na zaliczenie ćwiczeń z programowania w C#. Generuje ona tabliczki z numerami pokoi oraz nazwiskami, które mogą być wydrukowane i zawieszone obok drzwi pokoi. Aplikacja umożliwia wybór czcionki, loga oraz koloru tekstu. Pozwala także na zapisywanie projektu między sesjami."

  override val projects_generator_tabliczek_technicalDescription: String =
      "Interfejs stworzony w WPF."

  override val projects_scheduler_shortDescription: String =
      "Aplikacja do generowania grafiku zajęć zintegrowana z Discordem"

  override val projects_scheduler_description: String =
      "Aplikacja ta została stworzona dla ułatwienia organizacji moich korepetycji. W prosty sposób umożliwia mi dopisywanie nowych zajęć w grafiku. Aplikacja jest zintegrowana z Discordem, dzięki czemu mogę jednym kliknięciem aktualizować grafik na moim serwerze. Dodatkowo, automatycznie codziennie wysyłane są powiadomienia przypominające uczniom o zajęciach zaplanowanych na kolejny dzień. Automatycznie też pobiera obecny dzień roku i generuje grafik na najbliższy tydzień, dając możliwość ustawienia dnia, od którego będzie się zaczynał (np. dzisiaj lub jutro). Umożliwia także: ustawienie godziny początkowej i końcowej; wybór motywu; klasyfikację poszczególnych zajęć (ćwiczenia, wykłady, korepetycje (zdalne lub stacjonarne), zdarzenia jednorazowe itp.; wypisywanie dat."

  override val projects_scheduler_technicalDescription: String =
      "Obraz w całości generowany jest w bibliotece Pillow. Integracja z Discordem poprzez bota, sterowanego za pomocą biblioteki Discord.py. Powiadomienie zrealizowane za pomocą słownika, który mapuje imię (czasem z nazwiskiem) na id użytkownika na Discordzie."

  override val projects_binary_clock_shortDescription: String =
      "Zegar binarny z wykorzystaniem Compose Multiplatform"

  override val projects_binary_clock_description: String =
      "Zegar binarny z wykorzystaniem Compose Multiplatform"

  override val projects_subtitles_shifter_shortDescription: String =
      "Prosty skrypt umożliwiający przesunięcie napisów w plikach .srt"

  override val projects_subtitles_shifter_description: String =
      "Prosty skrypt umożliwiający przesunięcie napisów w plikach .srt. Został stworzony na moją indywidualną potrzebę, bym mógł przesunąć napisy, które nie pasowały do wersji filmu (były opóźnione o kilka sekund w przód lub tył)."

  override val projects_youtube_downloader_shortDescription: String =
      "Wielowątkowy skrypt, który umożliwia pobranie piosenek z serwisu YouTube"

  override val projects_youtube_downloader_description: String =
      "Dzięki tej aplikacji można pobrać playlistę ze Spotify, za pośrednictwem YouTube'a. Wymaga od użytkownika wyeksportowania playlisty do pliku .csv za pośrednictwem aplikacji Exportify, a następnie pobiera w osobnych wątkach piosenki z YouTube'a, wyszukując je po nazwie i autorze oraz zapisuje je w przejrzysty sposób - tworzy foldery z wykonawcami, a każdą piosenkę podpisuje jej tytułem."

  override val projects_tic_tac_toe_shortDescription: String =
      "Prosta gra w kółko i krzyżyk, którą można zagrać ze znajomym na Discordzie"

  override val projects_tic_tac_toe_description: String =
      "Prosta gra w kółko i krzyżyk, którą można zagrać ze znajomym na Discordzie"

  override val projects_crypto_tracker_shortDescription: String =
      "Aplikacja śledząca kursy kryptowalut"

  override val projects_crypto_tracker_description: String =
      "Aplikacja śledząca kursy kryptowalut. Umożliwia dodawanie kryptowalut do śledzenia, a także wyświetla ich aktualne kursy wraz z wykresem zmian w ciągu ostatnich 24 godzin."

  override val projects_tutor_website_shortDescription: String =
      "Strona z ofertą korepetycji, które prowadzę"

  override val projects_tutor_website_description: String =
      "Strona opracowana przeze mnie dotycząca mojej oferty korepetycji z matematyki i informatyki. Zawiera wszelkie szczegóły dotyczące lekcji, stawek, opinii i kontaktu ze mną. Strona została wykonana w pełni z użyciem Jetpack Compose."

  override val projects_mobile_remote_shortDescription: String =
      "Zestaw 2 aplikacji - klienta i serwera, które umożliwiają zdalną kontrolę multimediów"

  override val projects_mobile_remote_description: String =
      "Zestaw 2 aplikacji - klienta i serwera, które umożliwiają zdalną kontrolę multimediów. Aplikacja serwerowa jest uruchamiana na komputerze, a klient na telefonie. Dzięki temu można sterować odtwarzaniem filmów z poziomu telefonu, np. pauzować, przewijać do przodu lub do tyłu, zmieniać głośność i wyciszać dźwięk, będąc oddalonym od komputera."

  override val projects_mobile_remote_technicalDescription: String =
      "Zestaw dwóch aplikacji umożliwiających zdalną kontrolę multimediów w obrębie sieci lokalnej – klienta na Android i serwera na komputer.  Klient zbudowany w Kotlin z UI opartym na Jetpack Compose, architektura MVI. Wysyła zapytania HTTP do serwera przez Ktor Client. Adres IP serwera zapisywany lokalnie w DataStore Preferences. Aplikacja jednoekranowa.  Serwer zbudowany w Kotlin ze Spring Boot, wystawia REST API odbierane przez klienta. Sterowanie multimediami realizowane przez NirCmd – narzędzie wiersza poleceń do kontroli systemowych funkcji Windows, wywoływane z poziomu serwera."

  override val projects_todo_list_shortDescription: String =
      "Klasyczna mobilna aplikacja z zadaniami do zrobienia"

  override val projects_todo_list_description: String =
      "Klasyczna mobilna aplikacja z zadaniami do zrobienia. Umożlwia tworzenie, edycję i usuwanie zadań. Zadania posiadają swój priorytet oraz datę wykonania. Całość jest zapisywana offline na urządzeniu"

  override val projects_screenshot_processor_shortDescription: String =
      "Aplikacja ułatwiająca moją pracę nad Valorant Lineups"

  override val projects_screenshot_processor_description: String =
      "Aplikacja ułatwiająca moją pracę nad Valorant Lineups. Umożliwia ona szybkie zapisywanie screenshotów z gry w folderach, zgodnie z moją własną strukturą danych pod tę aplikację. Posiada listę umiejętności dla każdego agenta, spis map oraz typ screeshotów."

  override val projects_website_shortDescription: String = "Moja strona portfolio"

  override val projects_website_description: String =
      "Moja strona portfolio, którą właśnie przeglądasz. Stworzyłem ją tylko i wyłącznie przy użyciu Kobweb."

  override val projects_days_counter_shortDescription: String =
      "Aplikacja do odliczania dni pomiędzy datami"

  override val projects_days_counter_description: String =
      "Aplikacja do odliczania dni pomiędzy datami. Można ją uruchomić jako aplikację mobilną na Androida, desktopową lub webową. Pozwala zapisywać użytkownikowi dowolną liczbę par dat, pomiędzy którymi są obliczane: liczba dni, które minęły, liczba dni, które pozostały."

  override val projects_typing_speed_tester_shortDescription: String =
      "Aplikacja do sprawdzenia prędkości pisania na klawiaturze - mobilna, desktopowa i natywna webowa"

  override val projects_typing_speed_tester_description: String =
      "Aplikacja do sprawdzenia prędkości pisania na klawiaturze - mobilna, desktopowa i natywna webowa. Użytkownik wybiera tryb testu: na czas (15, 30 lub 60 sekund) lub do końca pewnego cytatu. Aplikacja na bieżąco daje feedback użytkownikowi w formie kolorowania tekstu, który już wpisał - czerwone lub zielone litery. Po zakończeniu testu wyświetlany jest wynik: liczba słów na minutę, procent poprawnie wpisanych liter oraz procent dokładności. Interfejs aplikacji jest prosty, bez zbędnych dodatków."

  override val projects_typing_speed_tester_technicalDescription: String =
      "Celem aplikacji było stworzenie projektu, który współdzieli logikę między wszystkie platformy, jednak interfejs pozostaje natywny dla każdej z nich. Android oraz desktop dzielą osobny moduł dla interfejsu w Compose Multiplatform. Webowa wersja używa natomiast interfejsu w Kobweb. Zastosowałem też Koin dla dependency injection, współdzielone między wszystkie platformy, dzięki czemu projekt może być używany jako template dla innych projektów wymagających wymienionych wcześniej rzeczy."

  override val projects_tic_tac_toe_kotlin_shortDescription: String =
      "Klient i serwer gry w kółko i krzyżyk w obrębie sieci lokalnej"

  override val projects_tic_tac_toe_kotlin_description: String =
      "Klient i serwer gry w kółko i krzyżyk w obrębie sieci lokalnej. Klient może być uruchomiony jako aplikacja desktopowa, webowa lub mobilna na Androidzie. Stworzona z użyciem socketów. Zapewnia type-safe obsługę komunikatów oraz ich weryfikację."

  override val projects_math_tools_shortDescription: String =
      "Aplikacja ułatwiająca prowadzenie zdalnych korepetycji z matematyki"

  override val projects_math_tools_description: String =
      "Aplikacja ułatwiająca prowadzenie zdalnych korepetycji z matematyki. Rysuje potrzebne obiekty, takie jak tabelki, układ współrzędnych, szachownice, bryły (ostrosłupy i graniastosłupy o różnych podstawach). Pozwala bardzo łatwo skopiować je do schowka z przeźroczystym tłem, dzięki czemu można je wkleić bezpośrednio w każdym programie graficznym, używanym do korepetycji."

  override val projects_function_solver_shortDescription: String =
      "Aplikacja do ćwiczenia odczytywania własności funkcji z wykresu"

  override val projects_function_solver_description: String =
      "Aplikacja do ćwiczenia odczytywania własności funkcji z wykresu. Stworzona na potrzeby maturzystów. Pozwala na efektywną naukę zadań z tej tematyki, solidnie przygotowując do matury. Aplikacja generuje wykresy, pozwala wpisywać odpowiedzi, sprawdza je, podaje poprawne rozwiązania. Odpowiedzi są zawsze skracane do najprostszej postaci, nawet w przypadku funkcji przedziałowych."

  override val projects_function_solver_technicalDescription: String =
      "Funkcje w programie traktowane są jako listy zbiorów punktów. Napisałem od podstaw generowanie ich wykresu w UI, z dopasowanymi parametrami układu współrzędnych, dbając, by funkcje miały 'sensowne' do oczytania parametry, (np. całkowite miejsca zerowe). Sam napisałem też algorytmy, określające wszelkie parametry funkcji (dziedzinę, zbiór wartości, przedziały monotoniczności, wartości dodanie/ujemne/niedodatnie/nieujemne, miejsca zerowe). Własne klasy do reprezentacji punków, przedziałów i zbiorów. Własny algorytm do normalizacji przedziałów."

  override val projects_calico_companion_shortDescription: String =
      "Aplikacja do przygotowania rozgrywki w papierowej wersji gry Calico"

  override val projects_calico_companion_description: String =
      "Aplikacja do przygotowania rozgrywki w papierowej wersji gry Calico. Użytkownik może wylosować koty, wzorki, projekty zależenie od liczby graczy. Aplikacja stworzona dla własnego użytku"

  override val projects_matura_tasks_hub_shortDescription: String =
      "Strona z zadaniami maturalnymi pogrupowanymi wg działów i podkategorii"

  override val projects_matura_tasks_hub_description: String =
      "Strona z zadaniami maturalnymi pogrupowanymi wg działów i podkategorii. Stworzona z myślą o moich uczniach. Usprawnia także prowadzenie przeze mnie korepetycji. Poza udogonieniami dostępnymi na innych stronach tego typu, wprowadziłem kategoryzację zadań wg ich częstości pojawiania się na maturze - od pewniaków maturalnych po niestandardowe zadania, by uczniowie przygotowujący się do matury wiedzieli, na których zadaniach powinni się skupić. Dodatkowo każde zadanie ma przycisk kopiowania do schowka, dzięki czemu każde zadanie mogę bardzo szybko skopiować i wkleić w programie graficznym wykorzsytywanym podczas korepetycji."

  override val projects_matura_tasks_hub_technicalDescription: String =
      "Strona zbudowana w Kobweb (Kotlin/JS), architektura MVI z ViewModelami do zarządzania ładowaniem danych; struktura danych podzielona na warstwy z uwagi na złożoność domeny. Strona statyczna – bez backendu aplikacyjnego. Dane zadań przechowywane w SQLite, eksportowane do plików JSON skryptem Python i bundlowane ze stroną. Treść zadań renderowana przez MathJax (LaTeX w przeglądarce). Obrazki do zadań generowane są z plików LaTeX – kompilowane do PDF, następnie konwertowane do SVG przez pdf2svg. Ciemne warianty obrazków generowane automatycznie osobnym skryptem Python. Kopiowanie zadania do schowka jako obrazek realizowane przez Snapdom – umożliwia szybkie wklejenie zadania na wirtualną tablicę podczas korepetycji online. Logowanie przez konto Google lub Discord oraz obsługa funkcji premium zrealizowane przez Supabase (Authentication + Database) z integracją Stripe do obsługi płatności. Dane użytkowników i zakupionych funkcji przechowywane w Supabase DB. Strona hostowana na własnym serwerze z własną domeną."

  override val projects_youtube_uploader_shortDescription: String =
      "Skrypt do zautomatyzowanego wrzucania filmów na YouTube"

  override val projects_youtube_uploader_description: String =
      "Skrypt do zautomatyzowanego wrzucania filmów na YouTube. Stworzony na potrzeby aplikacji Valorant Lineups oraz Egzaminów z Matematyki - potrzebowałem nagrać ponad 1000 filmów, stworzyć dla nich opisy i wrzucić na YouTube. Skrypt automatycznie pobiera dane z bazy danych, generuje tytuł i opis wg wzorca, a następnie uploaduje wszystko do serwisu i zapisuje w bazie danych link dla każdego rekordu."

  override val projects_video_processor_shortDescription: String =
      "Aplikacja umożliwiająca bardzo szybkie dodanie napisów do filmu"

  override val projects_video_processor_description: String =
      "Aplikacja umożliwiająca bardzo szybkie dodanie napisów do filmu. Stworzona na potrzeby Valorant Lineups, gdzie musiałem dodawać krótkie napisy wyjaśniające lineupy dla niektórych filmów. Dostępne narzędzia nie pozwalały edytować w ten specyficzny sposób jednego filmu w ciągu kilkunastu sekund wraz z nadpisaniem filmu w miejscu, natomiast moja aplikacja na to pozwala."

  override val projects_connect_four_shortDescription: String =
      "Przeglądarkowa wersja gry Connect Four"

  override val projects_connect_four_description: String =
      "Przeglądarkowa wersja gry Connect Four. Zbudowana w Compose HTML z oficjalnego template'u JetBrains. Stworzona jako projekt na staż w JetBrains. Poza standardową rozgrywką gra oferuje animacje, zapis stanu gry po odświeżeniu, responsywność, podświetlanie zwycięskiej czwórki."

  override val projects_daymath_image_viewer_shortDescription: String =
      "Aplikacja do przeglądania obrazów wyrenderowanych z kodu LaTeX"

  override val projects_daymath_image_viewer_description: String =
      "Aplikacja do przeglądania obrazów wyrenderowanych z kodu LaTeX. Pozwala mi na szybkie sprawdzenie, czy nie zrobiłem żadnych literówek ani innych błędów pracując nad zadaniami w aplikacji DayMath."

  override val projects_tutoring_work_sheet_shortDescription: String =
      "Aplikacja do śledzenia moich zarobków z korepetycji i odliczania podatku"

  override val projects_tutoring_work_sheet_description: String =
      "Aplikacja do śledzenia moich zarobków z korepetycji i odliczania podatku."

  override val projects_coroutines_learning_shortDescription: String =
      "Zestaw 15 projektów do nauki coroutines od podstaw - w trakcie wykonywania"

  override val projects_coroutines_learning_description: String =
      "Zestaw 15 projektów do nauki coroutines od podstaw. Początkowo aplikacje konsolowe, później z interfejsem graficznym. Szczegóły dostępne w pliku README w repozytorium"

  override val experience_title: String = "Doświadczenie zawodowe"

  override val experience_subtitle: String =
      "Zbiór moich doświadczeń zawodowych, w tym korepetycji i tworzenia aplikacji."

  override val experience_tutor_title: String = "Korepetytor matematyki"

  override val experience_tutor_responsibility_1: String =
      "Prowadzenie prywatnych lekcji 1 na 1 z uczniami"

  override val experience_tutor_responsibility_2: String =
      "Przygotowanie uczniów do matury i egzaminów ósmoklasisty"

  override val experience_tutor_responsibility_3: String =
      "Przygotowywanie materiałów do nauki, wykorzystując LaTeX i Manim"

  override val experience_app_developer_title: String = "Developer aplikacji"

  override val experience_app_developer_responsibility_1: String =
      "Tworzenie własnych aplikacji mobilnych na Androida"

  override val experience_app_developer_responsibility_2: String =
      "Rozwój aplikacji w oparciu o potrzeby użytkowników"

  override val students_taught: String = "Uczniowie"

  override val rating: String = "Ocena"

  override val reviews: String = "Opinie"

  override val apps_published: String? = null

  override val total_downloads: String = "Pobrania"

  override val home: String = "Praca z domu"

  override val self_employed: String = "Samozatrudnienie"

  override val commercial: String = "Komercyjne"

  override val primary_technologies: String = "Główne technologie"

  override val education_title: String = "Edukacja"

  override val education_subtitle: String =
      "Moje wykszałcenie informatyczne, w tym studia licencjackie i technikum."

  override val education_uj_degree: String = "Licencjat Informatyki"

  override val education_uj_organization: String = "Uniwersytet Jagielloński"

  override val education_zsz_degree: String = "Technik Informatyk"

  override val education_zsz_organization: String = "Zespół Szkół Zawodowych w Przeworsku"

  override val Poland: String = "Polska"

  override val Algebra: String = "Algebra"

  override val ComputerOrganizationAndArchitecture: String = "Organizacja i Architektura Komputerów"

  override val Programming: String = "Programowanie"

  override val LogicAndSetTheory: String = "Logika i Teoria Mnogości"

  override val MathematicalAnalysis: String = "Analiza Matematyczna"

  override val ProgrammingMethods: String = "Metody Programowania"

  override val OperatingSystems: String = "Systemy Operacyjne"

  override val AlgorithmsAndDataStructures: String = "Algorytmy i Struktury Danych"

  override val DiscreteMathematics: String = "Matematyka Dyskretna"

  override val Databases: String = "Bazy Danych"

  override val SoftwareEngineering: String = "Inżynieria Oprogramowania"

  override val ProbabilityAndStatistics: String = "Prawdopodobieństwo i Statystyka"

  override val ComputerNetworks: String = "Sieci Komputerowe"

  override val FormalLanguagesAndAutomata: String = "Języki Formalne i Automaty"

  override val NumericalMethods: String = "Metody Numeryczne"

  override val FunctionalProgramming: String = "Programowanie Funkcyjne"

  override val AndroidProgramming: String = "Programowanie urządzeń mobilnych - Android"

  override val DesignPatterns: String = "Wzorce Projektowe"

  override val CSharpProgramming: String = "Programowanie w C#"

  override val CognitiveSystems: String = "Cognitive Systems"

  override val CognitiveScience: String = "Kognitywistyka"

  override val WebProgramming: String = "Programowanie Webowe"

  override val FundamentalsOfAI: String = "Podstawy Sztucznej Inteligencji"

  override val English: String = "Język Angielski"

  override val Networking: String = "Sieci Komputerowe"

  override val HardwareMaintenance: String = "Urządzenia Komputerowe"

  override val CertificateCCNARoutingAndSwitchingIntroductionToNetworks: String =
      "Certyfikat: CCNA Routing and Switching: Introduction to Networks"

  override val CertificatePCAPProgrammingEssentialsInPython: String =
      "Certyfikat: PCAP: Programming Essentials in Python"

  override val CertificateNDGLinuxUnhatched: String = "Certyfikat: NDG Linux Unhatched"

  override val CertificateIntroductionToCybersecurity: String =
      "Certyfikat: Introduction to Cybersecurity"

  override val CertificateCybersecurityEssentials: String = "Certyfikat: Cybersecurity Essentials"

  override val CertificateBeYourOwnBoss: String = "Certyfikat: Be Your Own Boss"

  override val CertificateGetConnected: String = "Certyfikat: Get Connected"

  override val CertificateIntroductionToTheInternetOfEverything: String =
      "Certyfikat: Introduction to the Internet of Everything"

  override val Certificate3dsMaxAnimation: String = "Certyfikat: 3ds Max Animation"

  override val Certificate3dsMaxVisualisation: String = "Certyfikat: 3ds Max Visualisation"

  override val Certificate3dsMaxModeling: String = "Certyfikat: 3ds Max Modeling"

  override val CertificateEUCodeWeek: String = "Certyfikat: EU Code Week"

  override val CertificateCPAProgrammingEssentialsInCPlusPlus: String =
      "Certyfikat: CPA: Programming Essentials in C++"

  override val programming_and_software_engineering: String =
      "Programowanie i inżynieria oprogramowania"

  override val mathematics: String = "Matematyka"

  override val systems_and_computer_technology: String = "Systemy i technologie komputerowe"

  override val ai_and_cognitive_science: String = "SI i nauki kognitywistyczne"

  override val courses: String = "Kursy"

  override val professional_certificates: String = "Profesjonalne certyfikaty"

  override val achievements_title: String = "Osiągnięcia"

  override val achievements_subtitle: String =
      "Zbiór moich osiągnięć, w tym nagród i wyróżnień w konkursach z różnych dziedzin."

  override val programming_competitions: String = "Konkursy programistyczne"

  override val math_competitions: String = "Konkursy matematyczne"

  override val scholarships: String = "Stypendia"

  override val other_achievements: String = "Inne osiągnięcia"

  override val FirstPlaceInTheIndependenceDictationContest: String =
      "1. miejsce w Dyktandzie Niepodległościowym"

  override val PrzeworskCountyScholarship: String = "Stypendium Starosty Przeworskiego"

  override val FirstPlaceInTheExpertGroupAtThePix2019ContestNationalSchoolProgrammingChampionship:
      String =
      "1. miejsce w grupie EXPERT w Konkursie PIX 2019 - Ogólnopolskie Mistrzostwa Programowania Szkolnego"

  override val QualificationToTheSemiFinalsOfThePolishEditionOfTheInternationalPixProgrammingChallenge:
      String =
      "Kwalifikacja do półfinałów Polskiej Edycji Międzynarodowego Wyzwania Programowania Pix"

  override val HonorableMentionInTheNationalHistoryContestKrag: String =
      "Wyróżnienie w Ogólnopolskim Konkursie Historycznym \"Krąg\""

  override val SecondPlaceInThe24thProfJanMarszalMathematicsContestForMiddleSchools: String =
      "2. miejsce w 24. Konkursie Matematycznym dla Gimnazjów im. Prof. Jana Marszała"

  override val FirstPlaceInTheSchoolProgrammingContest: String =
      "1. miejsce w Szkolnym Konkursie Programistycznym"

  override val HonorableMentionInThe15thDistrictMathContestProcent: String =
      "Wyróżnienie w 15. Powiatowym Konkursie Matematycznym \"Procent\""

  override val FirstPlaceInThe14thDistrictMathContestForSecondYearMiddleSchoolStudents: String =
      "1. miejsce w 14. Powiatowym Konkursie Matematycznym dla Uczniów II Gimnazjum"

  override val SecondPlaceInTheSchoolEnglishContest: String =
      "2. miejsce w Szkolnym Konkursie Języka Angielskiego"

  override val HonorableMentionInTheInternationalMathContestKangurMatematyczny: String =
      "Wyróżnienie w Międzynarodowym Konkursie Matematycznym \"Kangur\""

  override val first_place: String = "1. miejsce"

  override val school: String = "Szkolny"

  override val regional: String = "Regionalny"

  override val national: String = "Ogólnopolski"

  override val international: String = "Międzynarodowy"

  override val district: String = "Powiatowy"

  override val social_media_title: String = "Social Media"

  override val social_media_subtitle: String =
      "Możesz mnie znaleźć na różnych platformach społecznościowych, gdzie dzielę się moimi animacjami matematycznymi."

  override val january: String = "Styczeń"

  override val february: String = "Luty"

  override val march: String = "Marzec"

  override val april: String = "Kwiecień"

  override val may: String = "Maj"

  override val june: String = "Czerwiec"

  override val july: String = "Lipiec"

  override val august: String = "Sierpień"

  override val september: String = "Wrzesień"

  override val october: String = "Październik"

  override val november: String = "Listopad"

  override val december: String = "Grudzień"

  override val now: String = "Teraz"

  override val n_apps_published: VoidPluralString =
      VoidPluralString(PluralForms(one = "Opublikowana aplikacja", few = "Opublikowane aplikacje", other = "Opublikowanych aplikacji", ), "pl")

  override val n_courses: LibresFormatNCourses =
      LibresFormatNCourses(PluralForms(one = "%1${'$'}s kurs", few = "%1${'$'}s kursy", other = "%1${'$'}s kursów", ), "pl")

  override val n_certificates: LibresFormatNCertificates =
      LibresFormatNCertificates(PluralForms(one = "%1${'$'}s certyfikat", few = "%1${'$'}s certyfikaty", other = "%1${'$'}s certyfikatów", ), "pl")

  override val n_achievements: LibresFormatNAchievements =
      LibresFormatNAchievements(PluralForms(one = "%1${'$'}s osiągnięcie", few = "%1${'$'}s osiągnięcia", other = "%1${'$'}s osiągnięć", ), "pl")

  override val n_years: LibresFormatNYears =
      LibresFormatNYears(PluralForms(one = "%1${'$'}s rok", few = "%1${'$'}s lata", other = "%1${'$'}s lat", ), "pl")
}
